import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { DateConvert } from '../../helper/DateConvert';
import { BaseUrl } from '../../helper/BaseUrl';

export default function NewsCard({ extraClass = "", initialData }) {
    const [allData, setAllData] = useState(initialData || []);
    const [visibleCount, setVisibleCount] = useState(6);
    const [isLoadMore, setIsLoadMore] = useState(true);
    const [hasFetched, setHasFetched] = useState(false);
    const fetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/medias`, {
                method: 'GET',
            });

            const result = await response.json();
            if (result.medias === false) {
                throw new Error(`API error: ${result.message}`);
            }
            setAllData(result.medias || []);
        } catch (error) {
            console.error('Fetch error:', error.message);
            setAllData([]);
        } finally {
            setHasFetched(true);
        }
    };

    useEffect(() => {
        fetcher();
    }, [])

    const handleLoadMore = () => {
        if (isLoadMore) {
            setVisibleCount(prev => Math.min(prev + 3, allData.length));

            if (visibleCount + 3 >= allData.length) {
                setIsLoadMore(false);
            }
        } else {
            setVisibleCount(6);
            setIsLoadMore(true);
        }
    };
    return (
        <>
            <section className={`blogpage  ${extraClass}`}>
                <div className="container">
                    <div className="row">
                        {allData && allData.slice(0, visibleCount).map((data, index) => (
                            <div className="col-lg-4 col-sm-6" key={index}>
                                <Link to={`${data?.slug}`} className="blogpost-box">
                                    <div className='blogpost-image'>
                                        <img src={data?.thumbnail ? `${BaseUrl}${data.thumbnail}` : undefined} loading="lazy" className="img-responsive" alt={data?.alt_thumbnail} />
                                    </div>
                                    <div className='blogpost-detail'>
                                        <div className="category">{DateConvert(data?.date)}</div>
                                        <span>{data?.title}</span>
                                        <div className='arrow-butn'>Learn More <img src="/assets/images/arrow.webp" loading="lazy" alt="arrow" /></div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                        {allData.length > 6 && (
                            <div className="col-lg-12">
                                <div className='text-center'>
                                    <Link onClick={handleLoadMore} className="default-btn"><span>View More</span></Link>
                                </div>
                            </div>
                        )}
                        {hasFetched && allData.length === 0 && (
                            <div className="error-top-messege">
                                <h3 className="heading">No Data Found</h3>
                                <p>There are no News listings available right now. We are continuously updating our portfolio to showcase our latest work.</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}
